import { Injectable, OnDestroy, inject } from '@angular/core';
import { environment } from '@env/environment';
import {
  HubConnectionBuilder,
  HttpTransportType,
  HubConnection,
} from '@microsoft/signalr';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

/** serves as download progress report service only */
@Injectable({ providedIn: 'root' })
export class ReportProgressService implements OnDestroy {
  private translate = inject(TranslateService);

  hubConnection: HubConnection;
  progressText$ = new Subject<string>();
  private readonly reportProgressMethodName = 'reportProgress';

  constructor() {
    this.setupConnectionForExcelDownload();
  }

  ngOnDestroy(): void {
    this.hubConnection.off(this.reportProgressMethodName);
  }

  private setupConnectionForExcelDownload(): void {
    const builder = new HubConnectionBuilder();
    this.hubConnection = builder
      .withUrl(environment.endpoints.progressHubApi, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .build();

    this.hubConnection.on(this.reportProgressMethodName, data => {
      this.progressText$.next(this.translate.instant(data));
    });
    this.hubConnection.start().then(() => {
      const sessionData = window.sessionStorage.getItem('0-viatracks.spa');
      if (sessionData) {
        const subId = JSON.parse(sessionData).userData.sub;
        this.hubConnection.invoke('LogMeIn', subId);
      }
    });
  }
}
